import { render, staticRenderFns } from "./FilesModal.vue?vue&type=template&id=ded45c9c&scoped=true"
import script from "./FilesModal.vue?vue&type=script&lang=js"
export * from "./FilesModal.vue?vue&type=script&lang=js"
import style0 from "./FilesModal.vue?vue&type=style&index=0&id=ded45c9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded45c9c",
  null
  
)

export default component.exports